import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScroollTableKalayNafroshraw from "./ScroollTableKalayNafroshraw";
import FillDetailKalayNafroshraw from "./FillDetailKalayNafroshraw";
const AllKalayNafroshraw = () => {
  return (
    <div>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <div className="row" style={{ backgroundColor: "#2C3539" }}>
          <div className="col-12 ">
            <FillDetailKalayNafroshraw />
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <ScroollTableKalayNafroshraw />
          </div>
        </div>
        <div className="row " style={{ backgroundColor: "#2C3539" }}>
          <div
            className="col-12 col-12"
            style={{ backgroundColor: "#2C3539" }}
          >
            <br /> <br /> <br /> <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllKalayNafroshraw;
